// src/app/layout/main-layout/main-layout.ts

import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NgOptimizedImage,
    AvatarModule,
    ButtonModule,
    MenuModule,
    DrawerModule,
    TooltipModule,
  ],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayout {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  drawerVisible = false;
  agentAvatar: string | undefined;
  agentInitials: string | undefined;

  navigationItems: MenuItem[] = [
    {
      label: 'Insights Dashboard',
      icon: 'pi pi-home',
      routerLink: '/dashboard',
      command: () => this.navigateTo('/dashboard'),
    },
    {
      label: 'Property Completion',
      icon: 'pi pi-check-circle',
      routerLink: '/property-completion',
      command: () => this.navigateTo('/property-completion'),
    },
  ];

  userMenuItems: MenuItem[] = [
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout(),
    },
  ];

  navigateTo(route: string) {
    this.router.navigate([route]);
    this.drawerVisible = false;
  }

  logout() {
    this.authService.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }
}
